import { useDispatch, useSelector } from 'react-redux'
import { useCallback } from 'react'
import { useEventSlug } from 'hooks'
import { UploadType, upload } from '../actions'
import { selectBooth } from '../fetchBoothSlice'
import useFetchBooth from './useFetchBooth'

export default (type: UploadType) => {
    const dispatch = useDispatch()
    const eventSlug = useEventSlug()
    const fetchBooth = useFetchBooth()
    const booth = useSelector(selectBooth)

    return useCallback(async (file: File, filename = '', supportTranslate = false, isNative = false) => {
        await dispatch(upload({
            type,
            eventSlug,
            boothSlug: booth?.slug,
            file,
            filename,
            supportTranslate,
            isNative
        }))
        fetchBooth()
    }, [booth, dispatch, eventSlug, fetchBooth, type])
}
